export default __webpack_public_path__ + "static/media/P2.e5209290.png";